import axios from 'components/Axios';
import { Likes, CommentLikes, ReplyLikes, Unlike } from '../APIEndPoint';

const AddLikes = (payload) => {
  const promise = axios.post(`${Likes}`, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const AddCommentLikes = (payload, method) => {
  const promise =
    method === 'post'
      ? axios.post(`${CommentLikes}`, payload && payload)
      : axios.delete(`${CommentLikes}`, {
          data: payload,
        });
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const AddReplyLikes = (payload, method) => {
  const promise =
    method === 'post'
      ? axios.post(`${ReplyLikes}`, payload && payload)
      : axios.delete(`${ReplyLikes}`, {
          data: payload,
        });
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const GetbyPostlikeList = (postId) => {
  const promise = axios.get(`${Likes}/byPostId/${postId}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetLikesById = (payload) => {
  const promise = axios.get(`${Likes}/byUserId/${payload}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const AddUnLikes = (payload) => {
  const promise = axios.post(`${Unlike}`, payload);
  const dataPromise = promise.then((response) => response.data);
  return dataPromise;
};

const DeleteCommentLike = (id) => {
  const promise = axios.delete(`${CommentLikes}/${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export {
  AddLikes,
  GetLikesById,
  AddCommentLikes,
  AddReplyLikes,
  AddUnLikes,
  DeleteCommentLike,
  GetbyPostlikeList,
};
